/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureSummary } from './CaptureSummary';
import {
    CaptureSummaryFromJSON,
    CaptureSummaryFromJSONTyped,
    CaptureSummaryToJSON,
    CaptureSummaryToJSONTyped,
} from './CaptureSummary';

/**
 * 
 * @export
 * @interface AnnotateCapturesResponse
 */
export interface AnnotateCapturesResponse {
    /**
     * 
     */
    captures: Array<CaptureSummary>;
}

/**
 * Check if a given object implements the AnnotateCapturesResponse interface.
 */
export function instanceOfAnnotateCapturesResponse(value: object): value is AnnotateCapturesResponse {
    if (!('captures' in value) || value['captures'] === undefined) return false;
    return true;
}

export function AnnotateCapturesResponseFromJSON(json: any): AnnotateCapturesResponse {
    return AnnotateCapturesResponseFromJSONTyped(json, false);
}

export function AnnotateCapturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnnotateCapturesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'captures': ((json['captures'] as Array<any>).map(CaptureSummaryFromJSON)),
    };
}

export function AnnotateCapturesResponseToJSON(json: any): AnnotateCapturesResponse {
    return AnnotateCapturesResponseToJSONTyped(json, false);
}

export function AnnotateCapturesResponseToJSONTyped(value?: AnnotateCapturesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'captures': ((value['captures'] as Array<any>).map(CaptureSummaryToJSON)),
    };
}

